import type { QueueSummary, QueueTreeNode } from "../queues";

const STRATEGY_LABELS: Readonly<Record<string, string>> = {
    dynamic: "Dynamic (scored)",
    absolute: "Absolute (top tier)",
};

export function strategyLabel(strategy: string): string {
    return STRATEGY_LABELS[strategy] ?? strategy;
}

// A weight is a positive, finite multiplier. Empty / non-numeric / <= 0 are
// all rejected so the editor can't write a value the server would bounce.
export function parseWeight(raw: string): number | null {
    const trimmed = raw.trim();
    if (trimmed.length === 0) return null;
    const n = Number(trimmed);
    if (!Number.isFinite(n) || n <= 0) return null;
    return n;
}

// Absolute rank is a positive integer (lower wins). Dynamic queues ignore it.
export function parseRank(raw: string): number | null {
    const trimmed = raw.trim();
    if (trimmed.length === 0) return null;
    const n = Number(trimmed);
    if (!Number.isInteger(n) || n < 1) return null;
    return n;
}

export function flattenQueues(nodes: readonly QueueTreeNode[]): QueueSummary[] {
    const out: QueueSummary[] = [];
    const walk = (ns: readonly QueueTreeNode[]): void => {
        for (const node of ns) {
            out.push(node.queue);
            walk(node.children);
        }
    };
    walk(nodes);
    return out;
}
